import { z } from "zod";
import type { TFunction } from "i18next";
import { UserRoleSchema, AccessModeSchema } from "@libs/shared-permissions";

export const getInviteFormSchema = (t: TFunction<"settings">) =>
  z.object({
    role: UserRoleSchema.refine((val) => val, { message: t("invite.roleRequired") }),
    accessMode: AccessModeSchema,
    firstName: z
      .string()
      .min(1, { message: t("invite.firstNameRequired") })
      .min(2, { message: t("invite.firstNameTooShort") }),
    lastName: z
      .string()
      .min(1, { message: t("invite.lastNameRequired") })
      .min(2, { message: t("invite.lastNameTooShort") }),
    email: z.string({ message: t("invite.emailRequired") }).email({ message: t("invite.emailInvalid") })
  });
